//# sourceMappingURL=my-date-selected.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydaterangepicker/dist/interfaces/my-date-selected.interface.js
// module id = 878
// module chunks = 9